import { render, staticRenderFns } from "./MessageSuccessFadeOut.vue?vue&type=template&id=80d857f6&scoped=true&"
import script from "./MessageSuccessFadeOut.vue?vue&type=script&lang=js&"
export * from "./MessageSuccessFadeOut.vue?vue&type=script&lang=js&"
import style0 from "./MessageSuccessFadeOut.vue?vue&type=style&index=0&id=80d857f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d857f6",
  null
  
)

export default component.exports